module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10 Prism Green.a6a0fe6a.png";